<div class="o-grid">
    @if (isEditing && isPatientProfile) {
        <div class="o-grid__row">
            <div class="o-grid__field">
                <mds-dropdown
                    [closeOnPageScroll]="false"
                    [formGrp]="paymentCardFormGroup"
                    [formCtrlName]="'paymentRecipientDropdownControl'"
                    [appearance]="'outline'"
                    [label]="'Payment Recipient (Stipend or Reimbursement)'"
                    [placeholder]="'Select Recipient'"
                    [options]="paymentRecipientSelectOptions"
                    id="paymentRecipient"
                    (selectionChange)="emitPaymentRecipientChange($event.value, { id: 'paymentRecipientRole' })"
                ></mds-dropdown>
            </div>
        </div>
        @if (patient?.paymentRecipientRole) {
            <div class="o-grid__row">
                <div class="o-grid__field half">
                    <mds-dropdown
                        [closeOnPageScroll]="false"
                        [formGrp]="paymentCardFormGroup"
                        [formCtrlName]="'preferredMethodDopdownControl'"
                        [appearance]="'outline'"
                        [label]="'Preferred Method'"
                        [placeholder]="'Select method'"
                        [options]="selectOptions"
                        id="preferredMethod"
                        (selectionChange)="emitSelectChange($event.value, { id: 'preferredPayment' })"
                    ></mds-dropdown>
                </div>
                <div class="o-grid__field half">
                    <mds-dropdown
                        [closeOnPageScroll]="false"
                        [formGrp]="paymentCardFormGroup"
                        [formCtrlName]="'preferredCurrencyDopdownControl'"
                        [appearance]="'outline'"
                        [label]="'Preferred Currency'"
                        [placeholder]="'Select currency'"
                        [options]="currencies"
                        id="currencies"
                        (selectionChange)="emitSelectChange($event.value, { id: 'preferredCurrency' })"
                    ></mds-dropdown>
                </div>
            </div>
            <!-- BANK DETAILS EDIT MODE -->
            <div class="o-grid__row">
                <div class="o-grid__field">
                    @if (showBankDetails(paymentCardFormGroup, paymentOptions)) {
                        <medpace-bank-details
                            [isEditing]="isEditing"
                            [patientInfo]="patient"
                            [parentFormGroup]="paymentCardFormGroup"
                        ></medpace-bank-details>
                    }
                </div>
            </div>
        }
    }
    <!-- PAYMENT CARD VIEW -->
    @else if (!isEditing && isPatientProfile) {
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Payment Recipient (Stipend or Reimbursement)</h5>
                    <span>{{ selectedPaymentRecipient?.name }}</span>
                </div>
            </div>
        </div>
        @if (patient?.paymentRecipientRole) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Preferred Method</h5>
                        <span>{{ patient?.preferredPayment }}</span>
                    </div>
                </div>
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Preferred Currency</h5>
                        <span>{{ patient?.preferredCurrency }}</span>
                    </div>
                </div>
            </div>
            <!-- BANK DETAILS COMPONENT VIEW MODE-->
            <div class="o-grid__row">
                <div class="o-grid__item">
                    @if (showBankDetails(paymentCardFormGroup, paymentOptions)) {
                        <medpace-bank-details
                            [isEditing]="isEditing"
                            [patientInfo]="patient"
                            [parentFormGroup]="paymentCardFormGroup"
                        ></medpace-bank-details>
                    }
                </div>
            </div>
        }
    }
    @if (patient?.paymentRecipientRole) {
        <h5>KYC Details (Know Your Customer)</h5>
        <medpace-kyc-card
            (inputChangeEvent)="passContentAlong($event)"
            [isAdmin]="isAdmin"
            [isEditing]="isEditing"
            [patientIdent]="patient?.patientIdentification"
            [patient]="patient"
            [parentFormGroup]="paymentCardFormGroup"
        ></medpace-kyc-card>
    }
</div>
